import { memo } from "react";

import Badge from "ui/components/Badge/Badge";
import {
  CRON_JOB_STATUS_LABELS,
  CRON_JOB_STATUS_VARIANTS,
} from "services/api/cronjobs/consts";
import { CronJobStatus } from "services/api/cronjobs/types";

interface CronJobStatusBadgeProps {
  status: CronJobStatus | string;
}

/** Status vrste obrade. Nepoznat status se ispisuje doslovno, sivo — ne izmišlja se oznaka. */
const CronJobStatusBadge: React.FC<CronJobStatusBadgeProps> = ({ status }) => {
  const known = status as CronJobStatus;

  return (
    <Badge
      text={CRON_JOB_STATUS_LABELS[known] ?? status}
      variant={CRON_JOB_STATUS_VARIANTS[known] ?? "secondary"}
      height="small"
      showDot={status === "running"}
    />
  );
};

export default memo(CronJobStatusBadge);
